import React from "react";
//#region types
import { NumberChartTagProps } from "models/propTypes/chartProps";
//#endregion
//#region components
import Tags from "../tags";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const NumberChartPercentageTag: React.FC<NumberChartTagProps> = (props) => {
  const { percentage } = props;

  const getLabelClass = (value: number) => {
    return value === 0 ? cssExports.yellowTag : value > 0 ? cssExports.greenTag : cssExports.redTag;
  };

  const getLabel = (value: number) => {
    return value > 0 ? `+${value}%` : `${value}%`;
  };

  return <Tags tags={[getLabel(percentage)]} className={getLabelClass(percentage)} />;
};

export default NumberChartPercentageTag;
